import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { meQueryOptions } from '@/features/me/api';
import { AppShell } from '@/layout/app-shell';
import { sessionStore } from '@/shared/auth/session-store';
import { useSession } from '@/shared/auth/use-session';

/**
 * 로그인 후 화면의 틀 — 세션이 없으면 로그인으로 보내고, 돌아올 경로를 기억한다.
 * 화면을 보는 중에 세션이 끝나는 경우(다른 탭 로그아웃·갱신 실패)는 루트의 SessionWatcher 가 옮긴다.
 */
export const Route = createFileRoute('/_app')({
  beforeLoad: ({ location }) => {
    if (!sessionStore.get()) {
      throw redirect({ to: '/login', search: { redirect: location.href } });
    }
  },
  loader: ({ context }) => {
    // 헤더의 이름·프로필 사진 — 기다리지 않고 미리 요청만 한다
    void context.queryClient.query(meQueryOptions()).catch(() => undefined);
  },
  component: AppLayout,
});

function AppLayout() {
  const session = useSession();
  if (!session) return null;

  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
